module.exports = __webpack_public_path__ + "img/check-double.528af6e6.svg";